import { render, staticRenderFns } from "./AlunosPesquisaAvancada.vue?vue&type=template&id=3ddff3ee"
import script from "./AlunosPesquisaAvancada.vue?vue&type=script&lang=js"
export * from "./AlunosPesquisaAvancada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports